import React, { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import { authFetch } from "../../lib/api"

const SUMMARY = [
  { key: "users", label: "Users", to: "/admin/users", icon: "fa-solid fa-users" },
  { key: "listings", label: "Listings", to: "/admin/listings", icon: "fa-solid fa-building" },
  { key: "bookings", label: "Bookings", to: "/admin/bookings", icon: "fa-solid fa-calendar-check" },
  { key: "quotes", label: "Quote requests", to: "/admin/quote-requests", icon: "fa-solid fa-file-invoice-dollar" },
  { key: "submissions", label: "Submissions", to: "/admin/contact-submissions", icon: "fa-solid fa-inbox" },
]

export default function AdminDashboardHome() {
  const [counts, setCounts] = useState({ users: 0, listings: 0, bookings: 0, quotes: 0, submissions: 0 })
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    Promise.all([
      authFetch("/api/admin/users?limit=1").then((r) => r.json()),
      authFetch("/api/admin/listings?limit=1").then((r) => r.json()),
      authFetch("/api/admin/bookings?limit=1").then((r) => r.json()),
      authFetch("/api/quote-requests?limit=1").then((r) => r.json()),
      authFetch("/api/admin/contact-submissions?limit=1").then((r) => r.json()),
    ])
      .then(([u, l, b, q, c]) => {
        if (cancelled) return
        setCounts({
          users: u.total != null ? u.total : (u.users || []).length,
          listings: l.total != null ? l.total : (l.listings || []).length,
          bookings: b.total != null ? b.total : (b.bookings || []).length,
          quotes: q.total != null ? q.total : (q.quoteRequests || []).length,
          submissions: c.total != null ? c.total : (c.contactSubmissions || []).length,
        })
      })
      .catch(() => {})
      .finally(() => {
        if (!cancelled) setLoading(false)
      })
    return () => {
      cancelled = true
    }
  }, [])

  return (
    <div className='dashboard-stack'>
      <section className='dashboard-welcome admin-welcome'>
        <div>
          <span className='dashboard-eyebrow'>Operations hub</span>
          <h2>Manage the people, properties, and requests behind Vista Hill.</h2>
          <p>
            Keep the platform tidy with fast access to listings, booking updates, quote
            requests, user activity, and contact submissions.
          </p>
        </div>
        <Link to='/admin/listings' className='dashboard-primary-action admin-primary-action'>
          <i className='fa-solid fa-plus'></i>
          Add listing
        </Link>
      </section>

      <section className='dashboard-summary admin-summary' aria-label='Admin summary'>
        {SUMMARY.map((item) => (
          <Link to={item.to} className='dashboard-summary__item' key={item.key}>
            <span className='dashboard-summary__icon'>
              <i className={item.icon}></i>
            </span>
            <span>{item.label}</span>
            <strong>{loading ? "-" : counts[item.key]}</strong>
          </Link>
        ))}
      </section>

      <section className='dashboard-two-column'>
        <div className='dashboard-card'>
          <div className='dashboard-card__header'>
            <div>
              <span className='dashboard-eyebrow'>Priority work</span>
              <h2>Admin shortcuts</h2>
            </div>
          </div>
          <div className='dashboard-action-list'>
            <Link to='/admin/quote-requests'>
              <i className='fa-solid fa-file-invoice-dollar'></i>
              <span>
                <strong>Review quote requests</strong>
                <small>Follow up on custom build and service inquiries.</small>
              </span>
            </Link>
            <Link to='/admin/bookings'>
              <i className='fa-solid fa-calendar-days'></i>
              <span>
                <strong>Update booking statuses</strong>
                <small>Confirm, complete, or cancel active booking records.</small>
              </span>
            </Link>
            <Link to='/admin/users'>
              <i className='fa-solid fa-user-shield'></i>
              <span>
                <strong>Manage accounts</strong>
                <small>Create staff accounts and inspect user activity.</small>
              </span>
            </Link>
          </div>
        </div>

        <div className='dashboard-card admin-insight-card'>
          <span className='dashboard-eyebrow'>Platform health</span>
          <h2>Keep content accurate and fresh.</h2>
          <p>
            A polished customer experience depends on clean listings, quick replies, and
            visible progress for every booking or inquiry.
          </p>
          <Link to='/'>View public site</Link>
        </div>
      </section>
    </div>
  )
}
